import dayjs from 'dayjs';
import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type {
  MonthlyActivityReport,
  TGetMonthlyActivityReportRequest,
  TGetMonthlyActivityReportResponse,
} from '/src/lib/types';

export class MonthlyActivityService {
  /**
   * Formats/calculates MonthlyActivity response data
   */
  private static _interceptor = (response: MonthlyActivityReport[]) => {
    // Pre-process the data
    if (response.length) {
      for (const item in response) {
        const d = response[item];
        let newData = [];
        const newItems: MonthlyActivityReport['items'] = {
          advances: [],
          revenue: [],
          principalPayments: [],
        };

        // Convert the dates into date objects
        d.month = dayjs(d.month, 'YYYY-MM');

        for (const category in d.items) {
          newData = [];
          if (d.items[category].length) {
            for (const categoryItem in d.items[category]) {
              const dataItem = d.items[category][categoryItem];

              // Remove items without value
              if (dataItem.value) newData.push(dataItem);
            }
          }
          newItems[category] = newData;
        }
        d.items = newItems;

        response[item] = d;
      }
    }

    // Return the data
    return response;
  };

  /**
   * Get Monthly Activity report
   */
  public static async get(req: TGetMonthlyActivityReportRequest): CancelablePromise<TGetMonthlyActivityReportResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/monthly-activity',
        query: req,
      })
    );
  }
}
